/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "printable_check": {
                "nested": {
                  "PrintableCheckPreview": {
                    "fields": {
                      "rendered": {
                        "type": "squareup.bbfrontend.common.printable_check.PrintableCheckPreview.Rendered",
                        "id": 1
                      },
                      "template": {
                        "type": "squareup.bbfrontend.common.printable_check.PrintableCheckPreview.Template",
                        "id": 2
                      }
                    },
                    "nested": {
                      "Rendered": {
                        "fields": {
                          "imageBytes": {
                            "type": "bytes",
                            "id": 1,
                            "rule": "optional"
                          },
                          "mimeType": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "imageAlt": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "Template": {
                        "fields": {
                          "amountLabel": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "payeeLabel": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "memoLabel": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "voidDisclaimer": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "businessName": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "preview": {
                        "oneof": ["rendered", "template"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.PrintableCheckPreview && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.PrintableCheckPreview?.nested?.Rendered && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.PrintableCheckPreview?.nested?.Template) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE PrintableCheckPreview @ squareup/bbfrontend/common/printable_check/printable_check.proto at 54:1
 */
export const PrintableCheckPreview = $root.lookupType('squareup.bbfrontend.common.printable_check.PrintableCheckPreview');
fixType(PrintableCheckPreview);
Builder.createAndAttachToType(PrintableCheckPreview);
/**
 * Server side rendered preview - clients can display image as is.
 *
 * SOURCE Rendered @ squareup/bbfrontend/common/printable_check/printable_check.proto at 61:3
 */
PrintableCheckPreview.Rendered = $root.lookupType('squareup.bbfrontend.common.printable_check.PrintableCheckPreview.Rendered');
fixType(PrintableCheckPreview.Rendered, {
  mimeType: {
    notEmpty: true
  },
  imageAlt: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PrintableCheckPreview.Rendered);
/**
 * Used by clients to render a fake preview of the check in real time.
 * [Figma](https://www.figma.com/file/PdRUFLLKeS9wBfhxNJhwET/Pay-bills-from-checking?node-id=2426%3A159305&t=E1Zv77ItNHFEBXTC-1)
 *
 * SOURCE Template @ squareup/bbfrontend/common/printable_check/printable_check.proto at 74:3
 */
PrintableCheckPreview.Template = $root.lookupType('squareup.bbfrontend.common.printable_check.PrintableCheckPreview.Template');
fixType(PrintableCheckPreview.Template, {
  amountLabel: {
    notEmpty: true
  },
  payeeLabel: {
    notEmpty: true
  },
  memoLabel: {
    notEmpty: true
  },
  voidDisclaimer: {
    notEmpty: true
  },
  businessName: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(PrintableCheckPreview.Template);